import { ContentDto } from '@diritto/common/content/dtos/content.dto';
import { ContentPublicRelayDto } from '@diritto/common/relay/dtos/content-relay.dtos';
import { BadgeType } from 'constants/cover';
import { useContentState } from 'state-hooks/contents/useContentState';
import { CoverBadge } from 'ui-components/common/CoverBadge';

const variant = {
  container: {
    topRight: 'absolute top-0 right-0 flex gap-0.5 p-1 z-[100]',
  },
} as const;

interface ContentCoverBadgeAdultOnlyProps {
  content: ContentDto | ContentPublicRelayDto;
}

export const ContentCoverBadgeAdultOnly = ({ content }: ContentCoverBadgeAdultOnlyProps) => {
  const state = useContentState(content);

  return (
    <>
      <div className={variant.container.topRight}>{state.isAdult && <CoverBadge type={BadgeType.Adult} />}</div>
    </>
  );
};
